import * as Utils from "@/utils.js";
import apiClient from "./Environment";

export default {
  getRoomTypesMapped(data) {
    return apiClient.get("/get-room-types-mapped", { params: data });
  },
  getRoomTypesAvailable(data) {
    return apiClient.get("/get-all-room-types-available", { params: data });
  },
  generateRoomTypesMappingsFromPms(data) {
    return apiClient.post("/generate-room-types-mappings-pms", data);
  },
  generateRoomTypesMappingsFromChannelManager(data) {
    return apiClient.post(
      "/generate-room-types-mappings-channel-manager",
      data
    );
  },
  generateRoomTypesMappingsFromBooking(data) {
    return apiClient.post("/generate-room-types-mappings-booking", data);
  },
  generateRoomTypesMappingsFromWeb(data) {
    return apiClient.post("/generate-room-types-mappings-web", data);
  },
  setRoomType(data) {
    return apiClient
      .post("/set-room-type", data)
      .then(response => response.data);
  },
  removeRoomType(data) {
    return apiClient
      .post("/remove-room-type", data)
      .then(response => response.data);
  },
  highlightRoomType(data) {
    return apiClient
      .post("/highlight-room-rate", data)
      .then(response => response.data);
  },
  setRoomTypePosition(data) {
    return apiClient
      .post("/set-room-type-position", data)
      .then(response => response.data);
  },
  getRoomTypePeriods(data) {
    return apiClient
      .get("/get-room-rate-periods" + Utils.buildGetParams(data))
      .then(response => response.data);
  },
  setRoomRatePeriods(data) {
    return apiClient
      .post("/set-room-rate-periods", data)
      .then(response => response.data);
  },
  getRoomRateRefPeriod(data) {
    return apiClient
      .get("/get-room-rate-ref-period" + Utils.buildGetParams(data))
      .then(response => response.data);
  },
  setRoomRateRefPeriod(data) {
    return apiClient
      .post("/set-room-rate-ref-calendar", data)
      .then(response => response.data);
  },
  getRefRecalcStatus(data) {
    return apiClient
      .get("/get-ref-recalc-status" + Utils.buildGetParams(data))
      .then(response => response.data);
  },
  getRoomTypeMappings(hotel_id) {
    return apiClient.get("/get-room-type-mappings?hotel_id=" + hotel_id);
  },
  getCompsetRoomTypesForMapping(hotel_id) {
    return apiClient.get(
      "/get-compset-room-types-for-mapping?hotel_id=" + hotel_id
    );
  },
  setRoomTypeMapping(data) {
    return apiClient.post("/set-room-type-mapping", data);
  },
  deleteRoomTypeMapping(data) {
    return apiClient.post("/delete-room-type-mapping", data);
  },
  reorderRoomTypeMappings(data) {
    return apiClient.post("/reorder-room-type-mappings", data);
  },
  assignRoomTypeToMapping(data) {
    return apiClient.post("/assign-room-type-to-mapping", data);
  },
  unassignRoomTypeToMapping(data) {
    return apiClient.post("/unassign-room-type-to-mapping", data);
  }
};
